import type { PendingMpQrSaleSummary } from '../infra/pendingMpQrSalesRepo';
import { formatMoney } from '../../shared/format/public-api';

export function sumPendingMpQrAmount(sales: PendingMpQrSaleSummary[]): number {
  return sales.reduce((sum, sale) => sum + (sale.pendingAmount > 0 ? sale.pendingAmount : sale.total), 0);
}

export function formatMpQrPendingBannerLabel(count: number, totalAmount: number): string {
  const formatted = `${formatMoney(Math.round(totalAmount))}`;
  if (count === 1) return `1 cobro QR pendiente · ${formatted}`;
  return `${count} cobros QR pendientes · ${formatted}`;
}

export function formatSyncFailedSalesBannerLabel(count: number): string {
  if (count === 1) return '1 venta todavía no subió';
  return `${count} ventas todavía no subieron`;
}
